import type { TFunction } from 'i18next'
import {
  FootIcon,
  SeaIcon,
  TreeIcon,
  MudIcon,
  SnowIcon,
  CowIcon,
  FoodIcon,
  BlockIcon,
  PetIcon,
  DishesIcon,
  BabyIcon,
  TiviIcon,
  DevelopIcon,
  PrimaryIcon,
  AllIcon,
  FarmIcon,
  CarFreeAccessibleIcon,
  PhotoShareIcon,
  HistoricIcon,
  CarIcon,
  HomeTownIcon,
} from './Icon'

export const categoryList = (lang: string, t: TFunction) => {
  let categoryList = [
    {
      id: 0,
      name: t('top.category_list.all'),
      type: 'clear',
      value: lang == 'en' ? 'all' : t('top.category_list.all'),
      icon: AllIcon,
    },
    {
      id: 1,
      name: t('top.category_list.walk_to_preschool'),
      value: lang == 'en' ? 'walk_to_preschool' : t('top.category_list.walk_to_preschool'),
      type: 'room_environment',
      icon: FootIcon,
    },
    {
      name: t('top.category_list.sea_play'),
      id: 3,
      value: lang == 'en' ? 'sea_play' : t('top.category_list.sea_play'),
      type: 'feature',
      icon: SeaIcon,
    },
    {
      id: 4,
      name: t('top.category_list.forest_play'),
      type: 'feature',
      value: lang == 'en' ? 'forest_play' : t('top.category_list.forest_play'),
      icon: TreeIcon,
    },
    {
      id: 5,
      name: t('top.category_list.snow_play'),
      type: 'feature',
      value: lang == 'en' ? 'snow_play' : t('top.category_list.snow_play'),
      icon: SnowIcon,
    },
    {
      id: 10,
      name: t('top.category_list.elementary_ok'),
      icon: PrimaryIcon,
      value: lang == 'en' ? 'elementary_ok' : t('top.category_list.elementary_ok'),
      type: 'feature',
    },
    {
      id: 11,
      name: t('top.category_list.animal_contact'),
      type: 'feature',
      value: lang == 'en' ? 'animal_contact' : t('top.category_list.animal_contact'),
      icon: CowIcon,
    },
    {
      id: 14,
      name: t('top.category_list.baby_friendly'),
      icon: BabyIcon,
      value: lang == 'en' ? 'baby_friendly' : t('top.category_list.baby_friendly'),
      type: 'room_environment',
    },
    {
      id: 15,
      name: t('top.category_list.with_coworking'),
      icon: TiviIcon,
      value: lang == 'en' ? 'with_coworking' : t('top.category_list.with_coworking'),
      type: 'room_environment',
    },
    {
      id: 16,
      name: t('top.category_list.preschool_photo_sharing'),
      icon: PhotoShareIcon,
      value: lang == 'en' ? 'preschool_photo_sharing' : t('top.category_list.preschool_photo_sharing'),
      type: 'feature',
    },
  ]

  if (lang === 'en') {
    categoryList = categoryList.concat([
      {
        id: 2,
        name: t('top.category_list.car_free_accessible'),
        icon: CarFreeAccessibleIcon,
        value: 'car_free',
        type: 'no_car',
      },
      {
        id: 6,
        name: t('top.category_list.farm_experience'),
        value: 'farm_experience',
        type: 'feature',
        icon: FarmIcon,
      },
      {
        id: 7,
        name: t('top.category_list.historic_streets'),
        icon: HistoricIcon,
        value: 'historic_streets',
        type: 'feature',
      },
      {
        id: 9,
        name: t('top.category_list.english_available'),
        icon: BlockIcon,
        value: 'english_available',
        type: 'feature',
      },
    ])
  } else {
    categoryList = categoryList.concat([
      {
        id: 6,
        name: t('top.category_list.mud'),
        type: 'feature',
        value: '泥んこ',
        icon: MudIcon,
      },
      {
        id: 8,
        name: t('top.category_list.food_education'),
        type: 'feature',
        value: '食育',
        icon: FoodIcon,
      },
      {
        id: 9,
        name: t('top.category_list.english_education'),
        icon: BlockIcon,
        value: '英語教育',
        type: 'feature',
      },
      {
        id: 10,
        name: t('top.category_list.developmental_support'),
        icon: DevelopIcon,
        value: '発達支援',
        type: 'feature',
      },
      {
        id: 12,
        name: t('top.category_list.pets_allowed'),
        type: 'room_environment',
        value: 'ペット可',
        icon: PetIcon,
      },
      {
        id: 13,
        name: t('top.category_list.stay_with_meals'),
        icon: DishesIcon,
        value: '食事付の宿',
        type: 'room_environment',
      },
      {
        id: 17,
        name: t('top.category_list.walkable_access'),
        icon: CarIcon,
        value: '留学レンタカー',
        type: 'feature',
      },
      {
        id: 18,
        name: t('top.category_list.home_town'),
        icon: HomeTownIcon,
        value: 'ふるさと納税',
        type: 'feature',
      },
    ])
  }

  return categoryList.sort((a, b) => a.id - b.id)
}
